import { render } from "./TheLocationVehicles.vue?vue&type=template&id=3a7ca6b1"
import script from "./TheLocationVehicles.vue?vue&type=script&lang=js"
export * from "./TheLocationVehicles.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__